import { Container } from "@/components/ui/container";
import { Star, Quote } from "lucide-react";

export const SocialProofSection = () => {
  const customerLogos = [
    { name: "Burgerville", logo: "/lovable-uploads/5d01493d-ec13-4ea7-b07e-106a31456b3e.png" },
    { name: "PEC", logo: "/lovable-uploads/e40665b8-7f09-40d0-99d6-186ca019f985.png" },
    { name: "Skibowl", logo: "/lovable-uploads/b9396ce9-8439-4bc7-bc50-0e8740ca3de3.png" },
    { name: "Farm Credit", logo: "/lovable-uploads/81fc9627-891a-487d-ad5e-dfa2d54b4264.png" },
    { name: "Pacifica", logo: "/lovable-uploads/bb06f2e8-3f3b-44d5-b6cc-a1e791037853.png" },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <Container>
        {/* Testimonial */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 relative">
            <Quote className="h-12 w-12 text-edgefi-purple/20 absolute top-6 left-6" />
            <blockquote className="text-xl md:text-2xl text-gray-700 font-medium mb-6 relative z-10">
              "edgefi showed us how to eliminate overlapping tools, cut costs, and improve our Microsoft 365 security posture. We reduced spend by 20% without sacrificing protection."
            </blockquote>
            <div className="flex items-center justify-center space-x-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <cite className="text-gray-600">
              <span className="font-semibold">Sarah Johnson</span><br />
              <span className="text-sm">CFO, Regional Healthcare System</span>
            </cite>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">
            Trusted by CFO's and Leaders at
          </h3>
          
          {/* Customer Logos */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 items-center justify-items-center max-w-4xl mx-auto">
            {customerLogos.map((customer, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 w-full text-center">
                <img 
                  src={customer.logo} 
                  alt={`${customer.name} logo`}
                  className="w-full h-12 object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-edgefi-purple mb-2">30%</div>
            <div className="text-gray-600">Average Cost Reduction</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-edgefi-purple mb-2">$2M+</div>
            <div className="text-gray-600">Total Client Savings</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-edgefi-purple mb-2">100%</div>
            <div className="text-gray-600">Client Retention Rate</div>
          </div>
        </div>
      </Container>
    </section>
  );
};